<template>
  <div style="width: 100vw; height: 100vh; overflow: hidden" :headers="headers">
    <!-- <h1>正在进行跳转...</h1> -->
  </div>
</template>
<script>
import { Loading } from "element-ui"
import { getuserinfo } from "@/api/user"
import {
  // setIdentifierToken,
  setWebNameToken,
  setWebAvaterToken,
  setRedirecttypeToken,
  setSignToken,
  setToken,
} from "@/utils/auth"

export default {
  name: "noPasswordLogin",
  data () {
    return {
      // headers: {
      //   'redirecttype': '',
      //   'sign': '',
      // },
    }
  },
  computed: {
    token () {
      return this.$route.query.token
    },
    // identifier () {
    //   return this.$route.query?.identifier ?? ""
    // },
    // schoolid() {
    //   return this.$route.query.schoolid;
    // },
    redirecttype () {
      return this.$route.query.redirecttype
    },
    sign () {
      return this.$route.query.sign
    },
  },
  created () {
    this.token = this.$route.query.token
    // this.schoolid = this.$route.query.schoolid;
    this.redirecttype = this.$route.query.redirecttype
    this.sign = this.$route.query.sign

    let loadingInstance = Loading.service({
      text: "正在进行跳转...",
      background: "rgba(0, 0, 0, 0.7)",
      lock: true,
      spinner: "el-icon-loading",
      fullscreen: true,
    })
    if (this.token) {
      this.$store.commit("SET_MENU_ID", 0)
      window.localStorage.setItem("menuId", 0)
      setToken(this.token) // 登录成功保存token到cookie 字段为Admin-Token
      this.$store.commit("SET_TOKEN", this.token) // 登录成功保存token到vuex全局state
      setRedirecttypeToken(this.redirecttype)
      setSignToken(this.sign)
      // if (this.identifier) {
      //   setIdentifierToken(this.identifier)
      //   this.$store.commit("SET_Identifier", this.identifier) //获取用户身份信息
      // }
      // this.headers['redirecttype']= this.redirecttype;
      // this.headers['sign'] = this.sign;
      this.$nextTick(() => {
        loadingInstance.close()
        this.getuserinfo()
      })
    }
  },
  methods: {
    getuserinfo () {
      getuserinfo()
        .then((response) => {
          if (response.code === 0) {
            //console.log("response", response);
            this.$store.commit("SET_Username", response.data.name)
            setWebNameToken(response.data.name)
            this.$store.commit("SET_Useravater", response.data.avatar)
            // localStorage.setItem("username", response.data.name)
            localStorage.setItem("usernumber", response.data.username)
            setWebAvaterToken(response.data.avatar)
            this.$router.push({ path: "/home" })
          }
        })
        .catch((error) => { })
    },
  },
};
</script>
<style scoped>
h1 {
  font-size: 30px;
  color: darkcyan;
}
</style>
